import { Action } from "@ngrx/store";
import { IShared } from "../../models/shared";

export enum ESharedActions {
  FetchRealEstateTypesAttempt = "[Shared] Fetch Real Estate Types Attempt",
  FetchRealEstateTypesSuccess = "[Shared] Fetch Real Estate Types Success",
  FetchRealEstateTypesFailed = "[Shared] Fetch Real Estate Types Failed",
  FetchAuctionStatusesAttempt = "[Shared] Fetch Auction Statuses Attempt",
  FetchAuctionStatusesSuccess = "[Shared] Fetch Auction Statuses Success",
  FetchAuctionStatusesFailed = "[Shared] Fetch Auction Statuses Failed",
}

export class FetchRealEstateTypesAttempt implements Action {
  public readonly type = ESharedActions.FetchRealEstateTypesAttempt;
  constructor() {}
}

export class FetchRealEstateTypesSuccess implements Action {
  public readonly type = ESharedActions.FetchRealEstateTypesSuccess;
  constructor(public payload: any) {}
}

export class FetchRealEstateTypesFailed implements Action {
  public readonly type = ESharedActions.FetchRealEstateTypesFailed;
  constructor() {}
}

export class FetchAuctionStatusesAttempt implements Action {
  public readonly type = ESharedActions.FetchAuctionStatusesAttempt;
  constructor() {}
}

export class FetchAuctionStatusesSuccess implements Action {
  public readonly type = ESharedActions.FetchAuctionStatusesSuccess;
  constructor(public payload: any) {}
}

export class FetchAuctionStatusesFailed implements Action {
  public readonly type = ESharedActions.FetchAuctionStatusesFailed;
  constructor() {}
}

export type SharedActions =
  | FetchRealEstateTypesAttempt
  | FetchRealEstateTypesSuccess
  | FetchRealEstateTypesFailed
  | FetchAuctionStatusesAttempt
  | FetchAuctionStatusesSuccess
  | FetchAuctionStatusesFailed;
